import { render, staticRenderFns } from "./PreviewButtonElement.vue?vue&type=template&id=0979be61&"
import script from "./PreviewButtonElement.vue?vue&type=script&lang=js&"
export * from "./PreviewButtonElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports